import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React from 'react';

import { FlexRow } from 'ui-components/components/flex';
import { MDash } from 'ui-components/components/mdash';

import styles from './refund-details-section.module.less';
import LabeledRow from '../../fulfillment-planner/labeled-row';

/**
 * @typedef {object} RefundDetailRowProps
 * @property {React.ReactNode} label - The label element (typically FormattedMessage)
 * @property {string} value - The value text
 * @property {boolean} [hasTooltip=false] - Whether to show info icon
 */

/**
 * Individual row component for displaying refund detail information
 * @param {RefundDetailRowProps} props
 * @returns {React.ReactElement|null} React element
 */
const RefundDetailRow = ({ label, value, hasTooltip = false }) => {
  const isEmptyValue = !value || value === '—';

  return (
    <LabeledRow className={styles['refund-row']} label={label} labelClassName={styles['refund-label']}>
      <FlexRow className={styles['refund-info']}>
        {isEmptyValue ? <MDash className={styles.mdash} /> : <span>{value}</span>}
        {hasTooltip ? <FontAwesomeIcon className={styles['refund-info-icon']} icon={faInfoCircle} size='sm' /> : null}
      </FlexRow>
    </LabeledRow>
  );
};

export default RefundDetailRow;
